export const COLORS = {
  I_BG: '#302e33',
  S_M_BG: '#302e33',
  S_BG: '#f2f4f7',
  S_WHITE_TEXT: '#e8ebef',
  S_GREY_TEXT: '#3c3c3c',
  S_DARK_TEXT: '#000000',
  I__L_TEXT: '#000000',
  I_TEXT: '#f2f4f7',
  PRIMARY: '#232323',
  SECONDARY: '#555555',
  DANGER: '#953232',
  WARNING: 'yellow',
  INFO: '#3d3e66',
  MUI_BLUE: '#3f51b5',
  VALID: '#56ab2f',
};

export const GRADIENTS =  {
  order: 'linear-gradient(to top left, #ec008c, #fc6767)',
  orange: 'linear-gradient(to bottom right, #e44d26, #f16529)',
  blue: 'linear-gradient(to bottom right, #8e2de2, #4a00e0)',
  yellow: 'linear-gradient(to bottom right, #f09819, #edde5d)',
  red: 'linear-gradient(to bottom right, #e52d27, #b31217)',
  green: 'linear-gradient(to bottom right, #a8e063, #56ab2f)',
  grey: 'linear-gradient(to bottom right, #232526, #414345)',
  infomui: `linear-gradient(to bottom right, ${COLORS.INFO}, ${COLORS.MUI_BLUE})`,
};

export const LINEARS = {
  order: '#fc6767',
  orange: '#f16529',
  blue: '#4a00e0',
  yellow: '#edde5d',
  red: '#b31217',
  green: '#56ab2f',
  grey: '#414345',
  infomui: '#3f51b5',
};